import { styled, Paragraph, GetProps } from 'tamagui'

export const FormErrorMessage = styled(Paragraph, {
  name: 'FormErrorMessage', // useful for debugging, and Component themes
  color: '$error.500',
  size: '$xs',
})

export type FormErrorMessageProps = GetProps<typeof FormErrorMessage>
